import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, Facebook, Twitter } from "lucide-react";
import { BRAND } from "@/constants/brand";
import { trackContact } from "@/lib/analytics";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-950 text-slate-300">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={BRAND.logo}
              alt="Logotipo de Clima Oliver"
              className="h-11 w-11 rounded-xl object-cover ring-1 ring-white/10"
            />
            <span className="font-display text-lg font-bold text-white">
              Clima <span className="text-ocean-500">Oliver</span>
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Empresa instaladora de aire acondicionado fundada en {BRAND.founded}. Rigor
            técnico y garantías reales por escrito en cada instalación.
          </p>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">
            Navegación
          </h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-inicio" to="/#inicio" className="transition-colors hover:text-white">Inicio</Link></li>
            <li><Link data-testid="footer-link-nosotros" to="/#nosotros" className="transition-colors hover:text-white">Sobre Nosotros</Link></li>
            <li><Link data-testid="footer-link-servicios" to="/#servicios" className="transition-colors hover:text-white">Servicios</Link></li>
            <li><Link data-testid="footer-link-garantias" to="/#garantias" className="transition-colors hover:text-white">Garantías</Link></li>
            <li><Link data-testid="footer-link-presupuesto" to="/presupuesto" className="transition-colors hover:text-white">Crear mi presupuesto</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white">
            Contacto
          </h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-ocean-500" />
              <a data-testid="footer-phone-link" href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noopener noreferrer" onClick={() => trackContact("whatsapp")} className="transition-colors hover:text-white">
                {BRAND.whatsappDisplay} (WhatsApp)
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-ocean-500" />
              <span data-testid="footer-location">Servicio en la provincia de Tarragona y Barcelona</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-ocean-500" />
              <a data-testid="footer-email-link" href="mailto:grupofamiliaoliver@gmail.com" className="transition-colors hover:text-white">
                grupofamiliaoliver@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="h-4 w-4 text-ocean-500" />
              <a data-testid="footer-instagram-link" href="https://www.instagram.com/climaoliversl" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                Instagram · climaoliversl
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Facebook className="h-4 w-4 text-ocean-500" />
              <a data-testid="footer-facebook-link" href="https://www.facebook.com/ClimaOliver" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                Facebook · Clima Oliver
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Twitter className="h-4 w-4 text-ocean-500" />
              <a data-testid="footer-x-link" href="https://x.com/ClimaOliver" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white">
                X · Clima Oliver
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row">
        <p>© {new Date().getFullYear()} Clima Oliver. Todos los derechos reservados.</p>
        <div className="flex items-center gap-5">
          <Link data-testid="footer-aviso-legal-link" to="/aviso-legal" className="transition-colors hover:text-white">Aviso Legal</Link>
          <Link data-testid="footer-privacidad-link" to="/privacidad" className="transition-colors hover:text-white">Política de Privacidad</Link>
          <Link data-testid="footer-cookies-link" to="/cookies" className="transition-colors hover:text-white">Política de Cookies</Link>
        </div>
        <p>Fundador: {BRAND.founder} · CEO y Cofundador: {BRAND.ceo}</p>
      </div>
    </div>
  </footer>
);
